import styles from '../../styles/lit-bundle/shared.scss';
import {CSSResult, unsafeCSS} from 'lit';

export const sharedCss: CSSResult = unsafeCSS(styles);
